module.exports = __webpack_public_path__ + "static/media/brand-car-wreck-home.8f747268.png";